import { Form, Modal, Radio } from 'antd'
import { ModalProps } from 'antd/lib/modal'

import { AcceptInfoItem, OrderDteailRes } from '../../../api/orderManage'
import Uploadfiles from '../../uploadfiles'
import { useSetupHook } from './hooks'

export const certificateList = [
  {
    type: '1',
    enName: 'invoice',
    label: '两单',
  },
  {
    type: '2',
    enName: 'account',
    label: '咸亨验收单',
  },
]

export interface Props extends ModalProps {
  detailInfo: OrderDteailRes
  onSubmitEnd?: () => void
  onCancel?: () => void
  getAddOrderAccept?: (val: any) => void
  currentEditItem?: AcceptInfoItem
}
export function UploadCertificateModal(props: Props) {
  const { detailInfo, ...restProps } = props
  const {
    isLoading,
    form,
    uploadFilesList,
    handleSubmit,
    handleModalCancel,
    handleUploadfilesChange,
  } = useSetupHook(props)

  return (
    <Modal
      title="上传凭证"
      okText="提交"
      {...restProps}
      onOk={handleSubmit}
      onCancel={handleModalCancel}
      confirmLoading={isLoading}
    >
      <Form form={form}>
        <Form.Item
          label="凭证类型"
          name="type"
          required
          rules={[{ required: true }]}
          initialValue={'2'}
        >
          <Radio.Group>
            {certificateList.map((item) => {
              return (
                <Radio value={item.type} key={item.type}>
                  {item.label}
                </Radio>
              )
            })}
          </Radio.Group>
        </Form.Item>
        <Form.Item label="凭证附件" required>
          <Uploadfiles
            title="选择文件"
            type="invoice"
            code={detailInfo?.id}
            dataSource={uploadFilesList}
            onChange={handleUploadfilesChange}
            accept=".jpg,.png,.jpeg,.pdf"
            maxCount={3}
            directlyDelete
          />
          <span style={{ color: '#919191', fontSize: '12px' }}>
            支持jpg、png、jpeg、pdf
          </span>
        </Form.Item>
      </Form>
    </Modal>
  )
}
import { Form, Modal, Radio } from 'antd'
import { ModalProps } from 'antd/lib/modal'

import { AcceptInfoItem, OrderDteailRes } from '../../../api/orderManage'
import Uploadfiles from '../../uploadfiles'
import { useSetupHook } from './hooks'

export const certificateList = [
  {
    type: '1',
    enName: 'invoice',
    label: '两单',
  },
  {
    type: '2',
    enName: 'account',
    label: '咸亨验收单',
  },
]

export interface Props extends ModalProps {
  detailInfo: OrderDteailRes
  onSubmitEnd?: () => void
  onCancel?: () => void
  getAddOrderAccept?: (val: any) => void
  currentEditItem?: AcceptInfoItem
}
export function UploadCertificateModal(props: Props) {
  const { detailInfo, ...restProps } = props
  const {
    isLoading,
    form,
    uploadFilesList,
    handleSubmit,
    handleModalCancel,
    handleUploadfilesChange,
  } = useSetupHook(props)

  return (
    <Modal
      title="上传凭证"
      okText="提交"
      {...restProps}
      onOk={handleSubmit}
      onCancel={handleModalCancel}
      confirmLoading={isLoading}
    >
      <Form form={form}>
        <Form.Item
          label="凭证类型"
          name="type"
          required
          rules={[{ required: true }]}
          initialValue={'2'}
        >
          <Radio.Group>
            {certificateList.map((item) => {
              return (
                <Radio value={item.type} key={item.type}>
                  {item.label}
                </Radio>
              )
            })}
          </Radio.Group>
        </Form.Item>
        <Form.Item label="凭证附件" required>
          <Uploadfiles
            title="选择文件"
            type="invoice"
            code={detailInfo?.id}
            dataSource={uploadFilesList}
            onChange={handleUploadfilesChange}
            accept=".jpg,.png,.jpeg,.pdf"
            maxCount={3}
            directlyDelete
          />
          <span style={{ color: '#919191', fontSize: '12px' }}>
            支持jpg、png、jpeg、pdf
          </span>
        </Form.Item>
      </Form>
    </Modal>
  )
}
